import Projects from './Projects'

export default Projects
